import React, { Component } from "react";
import { translate } from "react-i18next";
import g from 'glamorous'

import colors from '../utils/colors'

import GhostButton from "./ghostButton";

const Wrapper = g.div({
  paddingLeft: '3rem',
  marginLeft: '3rem',
  borderLeft: `2px solid ${colors.mischka}`
})

class LanguageSwitcher extends Component {
  constructor(props) {
    super(props);
    const { i18n } = this.props;
    this.state = { language: i18n.languages.length> 0 ? i18n.languages[0] : i18n.language};

    this.handleChangeLanguage = this.handleChangeLanguage.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ language: nextProps.i18n.language });
  }

  handleChangeLanguage(lng) {
    const { i18n } = this.props;
    i18n.changeLanguage(lng);
  }

  renderLanguageChoice({ code, label }) {
    return (
      <GhostButton
        key={code}
        width="2rem"
        className={"size-10 weight-medium language_switcher " + (this.state.language === code ? 'selected' : '')}
        onClick={() => this.handleChangeLanguage(code)}
      >
        {label}
      </GhostButton>
    );
  }

  render() {
    const languages = [
      { code: "el", label: "GR" },
      { code: "en", label: "EN" },
    ];

    return (
      <Wrapper className="LanguageSwitcher">
        {languages.map(language => this.renderLanguageChoice(language))}
      </Wrapper>
    );
  }
}

export default translate()(LanguageSwitcher);



// WEBPACK FOOTER //
// ./src/components/languageSwitcher.js